export const sameDocumentIds = (left = [], right = []) => {
    const normalize = (values) => values.map((id) => String(id)).sort().join('\0');

    return normalize(left) === normalize(right);
};

export const documentIdsForProductSave = ({
    isEditing,
    canLinkDocuments,
    originalIds,
    currentIds,
}) => {
    if (!isEditing) {
        return currentIds.length > 0 ? currentIds : undefined;
    }

    if (!canLinkDocuments || !Array.isArray(originalIds)) {
        return undefined;
    }

    if (sameDocumentIds(originalIds, currentIds)) {
        return undefined;
    }

    return currentIds;
};

export const resolveCreatedProductId = (created) => {
    if (created === undefined || created === null || created === '') {
        return null;
    }

    if (typeof created === 'number' || typeof created === 'string') {
        return created;
    }

    return created.product_id || created.id || created.productId || created.product?.id || null;
};

export const productSaveErrorMessage = (error) => {
    const data = error?.response?.data;

    if (typeof data === 'string' && data.trim()) {
        return data;
    }

    if (typeof data?.error === 'string' && data.error.trim()) {
        return data.error;
    }

    if (typeof data?.message === 'string' && data.message.trim()) {
        return data.message;
    }

    if (data?.message && typeof data.message === 'object') {
        const nested = data.message.details?.error || data.message.error;

        if (typeof nested === 'string' && nested.trim()) {
            return nested;
        }
    }

    const errors = data?.errors;

    if (errors && typeof errors === 'object') {
        const first = Object.values(errors)
            .flat()
            .find((value) => typeof value === 'string' && value.trim());

        if (first) {
            return first;
        }
    }

    return '';
};

export const numericDocumentIds = (ids) => ids.map((id) => {
    const value = Number(id);

    return Number.isInteger(value) ? value : id;
});
